import gql from "graphql-tag";

export const REFRESH_EQUIPMENT_RESOURCES = gql`
  mutation refreshEquipmentResources {
    refreshEquipmentResources
  }
`;